import { __decorate } from "tslib";
import fetchFromCache from '@/utilities/fetchFromCache';
import { Module, VuexModule, MutationAction } from 'vuex-module-decorators';
let Equipment = class Equipment extends VuexModule {
    constructor() {
        super(...arguments);
        this.equipment = [];
        this.cachedVersion = 0;
    }
    async fetchEquipment() {
        const { data: equipment, cachedVersion } = await fetchFromCache(this, 'equipment', 'equipment');
        return { equipment, cachedVersion };
    }
};
__decorate([
    MutationAction({ mutate: ['equipment', 'cachedVersion'] })
], Equipment.prototype, "fetchEquipment", null);
Equipment = __decorate([
    Module({ namespaced: true, name: 'equipment' })
], Equipment);
export default Equipment;
